(function () {
  'use strict';

  function findHeaders(sectionId) {
    return Array.prototype.filter.call(
      document.querySelectorAll('.product-short-description .toggle-header'),
      function (header) {
        var action = header.getAttribute('onclick') || '';
        return action.indexOf("'" + sectionId + "'") !== -1 ||
          action.indexOf('"' + sectionId + '"') !== -1;
      }
    );
  }

  function updateHeader(header, isOpen) {
    header.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    var indicator = header.querySelector('.toggle-icon, .arrow, [class*="arrow"]');
    if (!indicator) {
      var candidate = header.lastElementChild;
      if (candidate && !candidate.matches('h1, h2, h3, h4, p')) indicator = candidate;
    }
    if (indicator) indicator.textContent = isOpen ? '−' : '+';
  }

  window.toggleSection = function (sectionId) {
    var content = document.getElementById(sectionId);
    if (!content) return false;

    var computedDisplay = window.getComputedStyle(content).display;
    var isOpen = !(content.hidden || computedDisplay === 'none');
    var shouldOpen = !isOpen;

    content.hidden = !shouldOpen;
    content.style.display = shouldOpen ? 'block' : 'none';
    findHeaders(sectionId).forEach(function (header) {
      updateHeader(header, shouldOpen);
    });
    return false;
  };

  function initialise() {
    document.querySelectorAll('.product-short-description .toggle-header').forEach(function (header) {
      var action = header.getAttribute('onclick') || '';
      var match = action.match(/toggleSection\s*\(\s*['"]([^'"]+)['"]\s*\)/);
      if (!match) return;
      var content = document.getElementById(match[1]);
      if (!content) return;
      header.setAttribute('role', 'button');
      header.setAttribute('tabindex', '0');
      header.setAttribute('aria-controls', match[1]);
      updateHeader(header, !(content.hidden || window.getComputedStyle(content).display === 'none'));
      header.addEventListener('keydown', function (event) {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          window.toggleSection(match[1]);
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialise, { once: true });
  } else {
    initialise();
  }
  document.addEventListener('shopify:section:load', initialise);
})();
